import { apiFetch } from './client';

/**
 * The message bus, as the runtime recorded it.
 *
 * `payload` is whatever the sender put there — shape varies by
 * `message_type` and nothing validates it on the way out, so it is
 * `unknown` here rather than `any`. A reader narrows it or renders it as
 * JSON; it does not get to pretend it knows.
 */

export interface BusMessage {
  id: number;
  message_id: string;
  correlation_id: string | null;
  sender: string;
  recipient: string;
  message_type: string;
  severity: string;
  payload: unknown;
  status?: string | null;
  created_at_ms?: number | null;
  claimed_at_ms?: number | null;
  processed_at_ms?: number | null;
  attempts?: number | null;
  error?: string | null;
}

export interface BusQuery {
  limit?: number;
  sender?: string;
  recipient?: string;
  message_type?: string;
  status?: string;
}

export function fetchBusMessages(q: BusQuery = {}): Promise<BusMessage[]> {
  const params = new URLSearchParams();
  if (q.limit) params.set('limit', String(q.limit));
  if (q.sender) params.set('sender', q.sender);
  if (q.recipient) params.set('recipient', q.recipient);
  if (q.message_type) params.set('message_type', q.message_type);
  if (q.status) params.set('status', q.status);
  const qs = params.toString();
  return apiFetch<BusMessage[]>(`/api/bus/messages${qs ? `?${qs}` : ''}`);
}

export function fetchBusMessage(messageId: string): Promise<BusMessage> {
  return apiFetch<BusMessage>(
    `/api/bus/messages/${encodeURIComponent(messageId)}`,
  );
}
